import { createContext } from 'react'

export const BreakpointContext = createContext<number>(0)
